import {
  sipCalculatorGraphData,
  sipCalculatorGraphDataB,
  calculateSipFutureValue,
  calculateLumpsumFutureValue,
} from '../constants';

export function getSipCalculatorGraphData(
  sipAmount: number,
  fundTypeInterestRate: number,
  isVariant: boolean
) {
  const data = [];
  const invetmentData = {
    name: 'You Have Invested',
    data: [],
  };
  const fdData = {
    name: 'FD Return',
    data: [],
  };
  const mfData = {
    name: "This Fund's Return",
    data: [],
  };
  const dataPoints = isVariant
    ? sipCalculatorGraphDataB
    : sipCalculatorGraphData;

  dataPoints.forEach(years => {
    invetmentData.data.push([years, 12 * years * sipAmount]);
    fdData.data.push([years, calculateSipFutureValue(sipAmount, years, 6.4)]);
    mfData.data.push([
      years,
      calculateSipFutureValue(sipAmount, years, fundTypeInterestRate),
    ]);
  });
  data.push(invetmentData, fdData, mfData);
  return data;
}

export function getLumpsumCalculatorGraphData(
  lumpsumAmount: number,
  fundTypeInterestRate: number,
  isVariant: boolean
) {
  const data = [];
  const invetmentData = {
    name: 'You Have Invested',
    data: [],
  };
  const fdData = {
    name: 'FD Returns',
    data: [],
  };
  const mfData = {
    name: "This Fund's Returns",
    data: [],
  };
  const dataPoints = isVariant
    ? sipCalculatorGraphDataB
    : sipCalculatorGraphData;
  lumpsumAmount = parseInt(lumpsumAmount, 10);

  dataPoints.forEach(years => {
    invetmentData.data.push([years, lumpsumAmount]);
    fdData.data.push([
      years,
      calculateLumpsumFutureValue(lumpsumAmount, years, 6.4),
    ]);
    mfData.data.push([
      years,
      calculateLumpsumFutureValue(lumpsumAmount, years, fundTypeInterestRate),
    ]);
  });
  data.push(invetmentData, fdData, mfData);

  return data;
}



// WEBPACK FOOTER //
// ./utils/graphUtils.ts